import axios from "../utils/axios";

export const getAllOrder = (filters) => {
  return axios.get(`api/order/all?${filters}`);
};
